/* eslint-disable import/first */
import React from 'react';
import { Grid } from '@material-ui/core';
// import Button from '@material-ui/core/Button';
// Eslint fix
import { FaChevronDown } from '@react-icons/all-files/fa/FaChevronDown';
import { Slices, Redux } from 'spwa-ui-library';
// import { handleCountryPopup } = Slices.appSlice;
// import { selectCurrentCountry } = Slices.profileSlice;
// import {  } from 'spwa-ui-library';
import uaeIcon from '../SideMenu/images/uae.png';
import { FormattedMessage } from 'react-intl';
import bhrIcon from '../SideMenu/images/bahrain.png';
import egpIcon from '../SideMenu/images/egypt.png';
import kuwaitIcon from '../SideMenu/images/kuwait.png';
import omIcon from '../SideMenu/images/oman.png';
import jordanIcon from '../SideMenu/images/jordan.png';
import ksaIcon from '../SideMenu/images/ksa.jpg';
import qtrIcon from '../SideMenu/images/qatar.png';
import css from './index.module.scss';
import ClassNames from 'classnames';
const { useSelector, useDispatch } = Redux;
export const countryList = [
  { name: 'United Arab Emirates', code: 'UAE', flag: uaeIcon },
  // { name: 'Bahrain', code: 'BHR', flag: bhrIcon },
  // { name: 'Egypt', code: 'EGY', flag: egpIcon },
  // { name: 'Kuwait', code: 'KWT', flag: kuwaitIcon },
  // { name: 'Oman', code: 'OMN', flag: omIcon },
  // { name: 'Jordan', code: 'JOR', flag: jordanIcon },
  // { name: 'Qatar', code: 'QAT', flag: qtrIcon },
  { name: 'Saudi Arabia', code: 'KSA', flag: ksaIcon },
];
const { handleCountryPopup } = Slices.appSlice;
const { selectCurrentCountry } = Slices.profileSlice;
const CountrySelection = ({
  showCountryDropDown = true,
  showName = true,
  onlyChangeButton = false,
  hideName = false,
  overrideCountry = '',
  countryCode = '',
}) => {
  const currentCountry = useSelector(selectCurrentCountry);
  let country = countryList.find(({ code }) => code === currentCountry);
  country = country || countryList[0];
  const dispatch = useDispatch();
  const openCountryDrawer = () => {
    if (showCountryDropDown) dispatch(handleCountryPopup());
  };
  if (overrideCountry !== '') {
    const findCountry = countryList.find(({ code }) => code === overrideCountry);
    country = findCountry;
  }
  return (
    <>
      {!onlyChangeButton ? (
        <Grid
          className={ClassNames(css.root, { [css.fixWidth]: hideName })}
          onClick={openCountryDrawer}
        >
          <Grid className={css.country}>
            <img alt="country flag" src={country.flag} width="25" height="18" />
            {countryCode && <span className={css.countryCode}>{countryCode}</span>}
            <label className={css.countryNameLabel}>
              {showCountryDropDown && <FaChevronDown className={css.iconDown} />}
            </label>
          </Grid>
        </Grid>
      ) : (
        <div className={css.changeButton}>
          <button onClick={openCountryDrawer} variant="outlined" color="secondary">
            <FormattedMessage id="changeCountry" defaultMessage="Change Country" />
          </button>
        </div>
      )}
    </>
  );
};

export default CountrySelection;
